module.exports = __webpack_public_path__ + "img/巢湖学院@2x.006efc79.png";